import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

const fmt = require("indian-number-format");

export default function DayRange({ symbol }) {
  const socket = useContext(SocketContext);

  const [low, setLow] = useState(null);
  const [high, setHigh] = useState(null);
  const [open, setOpen] = useState(null);
  const [close, setClose] = useState(null);
  const [ltp, setLtp] = useState(null);

  useEffect(() => {
    if (!socket || !symbol?.symbol_id) return;

    socket.emit("giverate", symbol.symbol_id);

    const tradeListener = (d) => {
      setHigh(d.High ?? high);
      setLow(d.Low ?? low);
      setOpen(d.Open ?? open);
      setClose(d.Previous_Close ?? close);
      setLtp(d.LTP ?? ltp);
    };

    socket.on(`trade${symbol.symbol_id}`, tradeListener);
    return () => socket.off(`trade${symbol.symbol_id}`, tradeListener);
  }, [socket, symbol, high, low, open, close, ltp]);

  // Calculate marker percentage position
  const percent =
    ltp && low && high && high !== low ? ((ltp - low) / (high - low)) * 100 : 0;

  return (
    <div className="px-4 pt-2 pb-4 border-t border-[var(--hover)]">
      <div className="text-sm font-semibold text-[var(--text)] mb-3">Day's range</div>

      {/* Low / High labels */}
      <div className="text-xs text-[var(--subtext)] flex justify-between mb-2">
        <div>Low</div>
        <div>High</div>
      </div>

      {/* RANGE BAR */}
      <div className="flex items-center gap-2">
        <div className="text-xs text-[var(--text)]">
          {fmt.format(low) || "--"}
        </div>

        <div className="flex-1">
          <div className="w-full bg-[var(--hover)] h-2 rounded-full relative overflow-hidden">
            {/* filled range between low → high */}
            <div
              className="absolute left-0 top-0 h-2 bg-[var(--buy)]"
              style={{ width: `${percent}%` }}
            />

            {/* current LTP marker triangle */}
            <div
              className="absolute"
              style={{ left: `calc(${percent}% - 4px)` }}
            >
              <div className="w-0 h-0 border-[5px] border-transparent border-t-[var(--text)] rotate-180" />
            </div>
          </div>
        </div>

        <div className="text-xs text-[var(--text)]">
          {fmt.format(high) || "--"}
        </div>
      </div>

      {/* OPEN / CLOSE */}
      <div className="flex justify-between items-center mt-3 text-xs text-[var(--subtext)]">
        <div>Open {fmt.format(open) || "--"}</div>
        <div>Prev. close {fmt.format(close) || "--"}</div>
      </div>
    </div>
  );
}
